module.exports = __webpack_public_path__ + "img/item_to_up.33247f90.png";